<template>
  <div :class="{ 'c-dark-theme': false, animated: false, fadeIn: true }">
    <!-- 알림 사용자 리스트 ------------------------------------------------------>

    <CCard>

      <CCardBody class="p-1">
        <vue-excel-editor
          v-model="rows"
          ref="excelGrid"
          :page="numOfRecord"
          :readonly-style="{backgroundColor:'#4F5040'}"
          :localized-label="editorLabel"
          @select="selectRecord"
          @update="updateCell"
          filter-row>
          <vue-excel-column field="_id"         type="string"   key-field invisible/>
          <vue-excel-column field="name"        type="string"   width="85px"  label="수신자명" :to-text="v=>{return toNameMask(v) }" sticky/>
<!--          <vue-excel-column field="rank"        type="string"   width="50px"  label="직급" />-->
<!--          <vue-excel-column field="position"    type="string"   width="50px"  label="직책" />-->
          <vue-excel-column field="hpNo"        type="string"   width="110px"  label="휴대폰번호"
                            :to-text="v=>{return toPhoneMask(v)}" :to-value="v=>{return toPhoneVal(v)}" sticky/>
          <vue-excel-column field="enabled"     type="map"      width="60px" label="알림" :options="{true:'사용', false:'X'}"/>
          <vue-excel-column field="sType"       type="map"      width="90px" label="발송유형" :options="{AT:'알림톡', SMS:'SMS'}"/>
          <vue-excel-column field="tids"        type="string"   width="150px" label="대상탱크" :to-text="tidsText" readonly/>
          <vue-excel-column field="evt1"        type="checkYN"   width="60px" label="넘침"/>
          <vue-excel-column field="evt2"        type="checkYN"   width="60px" label="부족"/>
          <vue-excel-column field="evt3"        type="checkYN"   width="60px" label="화재"/>
          <vue-excel-column field="evt4"        type="checkYN"   width="60px" label="수분"/>
          <vue-excel-column field="evt5"        type="checkYN"   width="60px" label="누유"/>
          <vue-excel-column field="evt6"        type="checkYN"   width="60px" label="넘침2"/>
          <vue-excel-column field="evt7"        type="checkYN"   width="60px" label="부족2"/>
          <vue-excel-column field="evt9"        type="checkYN"   width="60px" label="점검"/>

          <vue-excel-column field="startDt"     type="date" width="120px" label="시작일"/>
          <vue-excel-column field="endDt"       type="date" width="120px" label="종료일"/>
          <vue-excel-column field="fromTime"    type="string"   width="100px" label="시작시간" :to-value="v=>{return toHHmm(v)}"/>
          <vue-excel-column field="toTime"      type="string"   width="100px" label="종료시간" :to-value="v=>{return toHHmm(v)}"/>

          <vue-excel-column field="updatedAt"   type="datetime" width="120px" label='수정일' :to-text="toLocalTime" readonly/>
          <vue-excel-column field="updId"       type="string"   width="80px" label='수정자' readonly/>
<!--          <vue-excel-column field="createdAt"   type="datetime" width="110px" label='등록일' :to-text="toLocalTime" readonly/>-->
<!--          <vue-excel-column field="regId"       type="string"   width="80px" label='등록자' readonly/>-->
        </vue-excel-editor>

        <CRow class="mt-2">
          <CCol>
            <BButtonGroup>
            <BButton size="sm" variant="primary" class="mr-1" @click="addNoticeUser">
              <BIconNodePlusFill/> 추가
            </BButton>

              <BButton variant="info" size="sm" class="mr-3"
                       @click="noticeTest"
                       :disabled="selectedRows.length===0 || isNoticeTest">
                <BIconstack font-scale="0.98" :animation="isNoticeTest?'spin':'none'">
                  <BIconArrowClockwise/>
                </BIconstack>
                시험전송
              </BButton>



            <BButton variant="danger" size="sm"
                     @click="deleteRecord"
                     :disabled="selectedRows.length===0">
              <BIconTrashFill/> 삭제
            </BButton>

            </BButtonGroup>
          </CCol>

          <CCol class="text-right" sm="6">
            <BButtonGroup>
              <BButton variant="warning" size="sm" class="mr-2"
                       @click="clickUploadList">
                <BIconUpload/> 업로드
              </BButton>
              <BButton variant="info" size="sm" class="mr-2"
                       @click="downloadList">
                <BIconDownload/> 다운로드
              </BButton>
              <BButton variant="primary" size="sm" type="button" @click="reloadNoticeUser">
                <BIconBootstrapReboot/> 수신자 반영
              </BButton>
            </BButtonGroup>
          </CCol>
        </CRow>

        <!-- 관제탱크 설정: 행 선택 시 노출. 빈 목록이면 전체 탱크 경보 수신 -->
        <CCard class="mt-2 mb-0" v-if="selectedRows.length" border-color="info">
          <CCardBody class="p-2 small">
            <CRow>
              <CCol class="m-0">
                <strong>
                  <BIconDiagram3Fill class="mr-1"/>
                  대상탱크
                  <BBadge variant="info" class="ml-1">{{ selectedRows.length }}명</BBadge>
                </strong>
              </CCol>
            </CRow>
            <CRow class="ctl-tank-form align-items-center mt-1">
              <CCol col="auto" class="px-0 ml-3">
                <CSelect size="sm" class="mb-0 area-select"
                         wrapper-classes="input-group input-group-sm"
                         :value.sync="areaCode"
                         :options="areaOpts">
                  <template #append>
                    <BButton variant="info" size="sm" @click="addAreaTids"><BIconPlusCircleFill/></BButton>
                  </template>
                </CSelect>
              </CCol>
              <CCol col="auto" class="px-0">
                <CSelect size="sm" class="mb-0 tank-select"
                         wrapper-classes="input-group input-group-sm"
                         :value.sync="tankId"
                         :options="tankOpts">
                  <template #append>
                    <BButton variant="info" size="sm" @click="addTankTid"><BIconPlusCircleFill/></BButton>
                  </template>
                </CSelect>
              </CCol>
              <CCol col="auto" class="pl-1">
                <BButtonGroup>
                  <BButton variant="info" size="sm" @click="clearTids"><BIconCheckAll/>전체탱크</BButton>
                  <BButton variant="danger" size="sm" class="ml-1" @click="saveTids"><BIconSave2Fill/> 저장</BButton>
                </BButtonGroup>
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol class="tid-badges">
                <BBadge v-if="!editTids.length" variant="success">전체 탱크 수신</BBadge>
                <BBadge v-for="(v,i) of editTids" :key="i"
                        variant="primary"
                        class="mr-1"
                        v-b-tooltip.hover
                        :title="`[${v}] 클릭 삭제`"
                        @click="delTid(v)">{{ tankName(v) }}
                </BBadge>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCardBody>
    </CCard>



    <BModal id="modal-upload"
            ref="modalUpload"
            title="알림 수신자 파일 업로드"
            header-bg-variant="primary"
            centered
            scrollable
            no-close-on-backdrop>
      <CRow>
        <CCol sm="8">
          <b-form-file
            v-model="listFile"
            :state="Boolean(listFile)"
            accept=".xls, .xlsx, .cell"
            placeholder="파일 선택 또는 드래그&드랍"
            drop-placeholder="여기에 파일을 드랍"
            @input="excelFileSelected"
          />

        </CCol>
        <CCol>
          <BButton variant='primary'
                   :disabled="!Boolean(listFile)"
                   @click="clickImportRecords">파일 업로드</BButton>
        </CCol>
      </CRow>


    </BModal>

  </div>
</template>



<script>

//-------------------------------------------------------------------------------------------------
import '@/common/HelperMixin';
import {
  apiCall, apiMultiPart, cloneVar
} from '@/common/utils';
import {ExcelEditorLabel} from "@/common/constants";
// import * as XLSX from 'xlsx';
import moment from 'moment';

const _notice_user = {
  name        : '수신자',
  hpNo        : '010-0000-0000',
  enabled     : true,
  rank        : '직급',
  position    : '직책',
  startDt     : null, // 시작기간
  endDt       : null, // 종료기간
  sType       : 'AT',
  fromTime    : '00:00', // HH:mm
  toTime      : '23:59', // HH:mm
  evt1        : 'Y',
  evt2        : 'Y',
  evt3        : 'Y',
  evt4        : 'Y',
  evt5        : 'Y',
  evt6        : 'Y',
  evt7        : 'Y',
  evt8        : 'N',
  evt9        : 'N',
  evt10       : 'N',
  evt11       : 'N',
  evt12       : 'N',
  tids        : [], // 관제탱크(빈 배열이면 전체 탱크)
};

const noticeColMap = {
  name        : '수신자',
  hpNo        : '휴대폰번호',
  enabled     : '알림사용여부',
  rank        : '직급',
  position    : '직책',
  sType       : '전송유형',
  startDt     : '시작일',
  endDt       : '종료일',
  fromTime    : '시작시간',
  toTime      : '종료시간',
  repeatTime  : '반복횟수',
  evt1        : '넘침알림',
  evt2        : '부족알림',
  evt3        : '화재알림',
  evt4        : '수분알림',
  evt5        : '누유알림',
  evt6        : '넘침2',
  evt7        : '부족2',
  evt8        : '예비',
  evt9        : '점검',
  tids        : '대상탱크',
}

//----------------------------------------------------------------------------------------------------
export default {
  name: "NoticeUserList",
  components: {
  },
  props: {
    tid: { type: String, default: null },
    status: { type: Number, default: 1 },
    simple: { type: Boolean, default: false },
  },
  data () {
    return {
      noticeUser : null,
      selectedFile: null,
      isUpdatingRecord: false,
      isTransRecord: false,
      isUploadingTable: false,
      numOfRecord: 10,
      editorLabel: ExcelEditorLabel,
      pickerShow: false,
      oilCodeMap: this.$store.state.codeMaps['OIL_CODE'],
      tankTypeMap: this.$store.state.codeMaps['TANK_TYPE'],
      isCreateMode: false,
      isUploadMode: false,
      rows: [],
      selectedRows: [],

      formShow: false,
      isSubmitting: false,
      row: null,
      statusMap: { '0':'신규', '1':'현재', '2':'이전' },
      isNoticeTest: false,
      areaCode: '',
      tankId: '',
      editTids: [],
      tankOpts: this.$store.state.tanks['opts'],
      areaCodes: this.$store.state.area['codes'],
      listFile: null,
      isFileLoading: false,
      uploadCount: 0
    }

  },
  async created(){
    try{
      console.log("--- NoticeUserList created---------------------");

      await this.getList();
    }catch(err){
      console.log(err);
    }
  },

  computed: {
    // 지역콤보: 공통 옵션의 '미설정' 텍스트를 이 폼에서만 '지역선택'으로 표시
    areaOpts(){
      return (this.$store.state.area['opts'] || []).map(o =>
        o.value === '' ? { ...o, text: '지역선택', label: '지역선택' } : o
      );
    },
  },

  mounted() {
    console.log("--- NoticeUserList mounted---------------------");
    // below is not work!
  },

  methods: {

    async addNoticeUser(){
      try{

        this.noticeUser = cloneVar(_notice_user);
        this.noticeUser.name = (this.rows.length+1)+'수신자';
        this.noticeUser.startDt = moment().format('YYYY-MM-DD');
        this.noticeUser.endDt = moment().add(3,'year').endOf('day').format('YYYY-MM-DD');
        const r = await apiCall('post', `/api/notice/user`, this.noticeUser );
        console.log(r);
        if(r.code===200){
          await this.getList();
          this.noticeUser = null;
        }
        await this.toastResult(r, '수신자 추가');
      }catch(err){
        await this.alertError(err);
      }

    },

    async reloadNoticeUser(){
      try{
        const r = await apiCall('get', `/api/notice/user-reload`);
        console.log(r);
        await this.toastResult(r, '알림 수신자 정보 반영');
      }catch(err){
        await this.alertError(err);
      }
    },

    downloadList(){
      if(this.rows.length ){
        let filename = `notice-user-${moment().format('YYMMDD')}.xlsx`;
        this.$refs["excelGrid"].exportTable('xlsx', false, filename);
      }else{
        this.alertWarn('다운로드 할 수 없습니다.');
      }
    },

    clickUploadList(){
      this.listFile = null;
      this.$refs['modalUpload'].show();
    },

    async clickImportRecords() {
      if( !(await this.confirmModal('선택한 파일을 업로드 하시겠습니까?', '수신자 리스트 파일 업로드')) ){
        this.$refs['modalUpload'].hide();
        this.listFile = null;
      }else{
        await this.uploadFile();
      }
    },

    async uploadFile(){

      const formData = new FormData();
      formData.append("listFile", this.listFile);
      try {
        this.isFileLoading = true;
        const r = await apiMultiPart(`/api/notice/list-upload`, formData);

        if (r.code === 200) {
          this.listFile = null;
          await this.alertSuccess(`등록: ${r.result.inserted}건, 수정:${r.result.updated}건, 오류: ${r.result.skip}건 (${r.result.msg})`);
          await this.getList();
        }else{
          await this.alertDanger( r.message );
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isFileLoading = false;
        this.$refs['modalUpload'].hide();
      }
    },



    excelFileSelected() {
      console.log("############## excelFileSelected #################");
      // console.log( this.file );
      if (!this.listFile) return;
      console.log(this.listFile);
    },

    async updateCell(rec){

      let rc = rec.pop();
      if(!rc.keys[0]){
        alert( "KEY_NOT_FOUND" );
        return;
      }

      // console.log( "updateRecord--------- record.$id--->",rc.$id );
      // console.log( "updateRecord--------- record.keys[0]--->",rc.keys[0] );

      let r = null;

      let param = {};
      const objectId = rc.keys[0];
      const fieldName = rc.name;
      if(fieldName!=='enabled')  param[fieldName] = rc.newVal.trim().toUpperCase();
      else param[fieldName] = rc.newVal;

      try{
        console.log( 'old value --->',rc.oldVal, 'new value --->', rc.newVal );
        /*
        if(fieldName==='startDt'){
          param[fieldName] =  moment( rc.newVal, 'YYYY-MM-DD 00:00:00').toISOString();
        }else if(fieldName==='endDt'){
          param[fieldName] =  moment( rc.newVal, 'YYYY-MM-DD').endOf('day').toISOString();
        }
        */

        console.log( '-----> will be updated to --->', param);
        r = await apiCall("PUT", `/api/notice/user/${objectId}`, param);
        console.log( r );
        await this.toastResult(r, `${noticeColMap[fieldName]} 수정`);
      }catch(err){
        await this.alertDanger(err.message, r.code);
        console.log( err );
      }

    },
    async getList(){
      try{
        console.log( "getList() --- query-string ----> ");
        this.rows = [];
        const r = await apiCall('get', `/api/notice/user`);
        if(r.code===200){
          this.rows = r.result;
          await this.toastInfo(`알림 수신자 ${this.rows.length}건 조회됨`, 'info');
        }
        if( this.$refs['excelGrid'].selectedCount) this.$refs['excelGrid'].clearAllSelected();

      }catch(err){
        await this.alertDanger(err.message);
        console.log( err );
      }

    },

    async selectRecord(idx, evt){

      if(!evt){
        // this.tankFormShow = false;
        this.selectedRows = [];
        return;
      }
      console.log("------------ selectRecord ------------", idx.length);
      this.selectedRows = this.$refs['excelGrid'].getSelectedRecords();
      // 관제탱크 편집 폼: 첫 선택 수신자의 목록을 로드
      this.editTids = this.selectedRows.length ? [...(this.selectedRows[0].tids || [])] : [];
    },

    /** 관제탱크 셀 표시: 빈 목록이면 전체 */
    tidsText(v){
      if( !v || !v.length ) return '전체';
      return Array.isArray(v) ? v.join(',') : v;
    },

    /** 탱크ID -> 탱크명 (매핑 없으면 tid 그대로) */
    tankName(tid){
      const t = (this.$store.state.tanks['map'] || {})[tid];
      return (t && t.name) ? t.name : tid;
    },

    /** 선택 지역의 전체 탱크를 관제탱크 목록에 추가 */
    addAreaTids(){
      if( !this.areaCode || !this.areaCodes[this.areaCode] ) return;
      this.areaCodes[this.areaCode]['tanks'].map(t => this.editTids.push(t.tid));
      this.editTids = [...new Set(this.editTids)];
    },

    /** 개별 탱크를 관제탱크 목록에 추가 */
    addTankTid(){
      if( !this.tankId ) return;
      this.editTids.push(this.tankId);
      this.editTids = [...new Set(this.editTids)];
    },

    delTid(v){
      this.editTids = this.editTids.filter(t => t !== v);
    },

    /** 전체 탱크 수신으로 초기화 */
    clearTids(){
      this.editTids = [];
    },

    /** 선택된 수신자들에게 관제탱크 목록 저장 */
    async saveTids(){
      try{
        if( !this.selectedRows.length ) return;
        const names = this.selectedRows.map(r => r.name).join(', ');
        const desc = this.editTids.length ? `${this.editTids.length}개 탱크` : '전체 탱크';
        if( !(await this.confirmModal(`수신자 [${names}] 의 관제탱크를 ${desc} 수신으로 저장합니다. 진행하시겠습니까?`, '관제탱크 저장')) )
          return;

        let okCnt = 0, failCnt = 0;
        for( const record of this.selectedRows ){
          const r = await apiCall('PUT', `/api/notice/user/${record._id}`, { tids: this.editTids });
          if( r.code === 200 ) okCnt++;
          else failCnt++;
        }
        await this.toastInfo(`관제탱크 저장: 성공 ${okCnt}건, 실패 ${failCnt}건`, 'info');
        await this.getList();
        this.editTids = [];
        this.selectedRows = [];
      }catch(err){
        console.error(err);
        await this.alertDanger(err.message);
      }
    },

    async noticeTest(){
      try{

        let params = this.selectedRows;
        this.progCount = 0;
        this.totalCount = params.length;
        if(!params.length) return this.toastInfo('[선텍된 레코드 없음] 좌측의 번호를 클릭하여 레코드 선택');

        const confirmMsg = `${params.length} 개의 레코드에 대하여 테스트 전송 합니다. 진행 하시겠습니까?`;

        if( !(await this.confirmModal(confirmMsg, '알림 전송 시험')) ){
          return;
        }
        this.isNoticeTest = true;
        let failCnt = 0, okCnt = 0;
        for( let record of params){
          this.progCount++;
          const r = await apiCall('POST', `/api/notice/test`, record );
          // console.log( r );
          if( r.code===200 ){
            if( r.result===true ) okCnt++
            else failCnt++;
          }
        }
        await this.alertModal(`총 ${this.progCount}건 / 성공: ${okCnt} / 실패: ${failCnt}`, '시험전송 결과', 'warning');
        this.isNoticeTest = false;
      }catch(err){
        this.isNoticeTest = false;
        console.error( err );
      }finally{
        this.progCount = 0;
      }

    },

    async deleteRecord(){
      // let r = null, msg = null, notice = null;
      try{

        let params = this.selectedRows;
        this.progCount = 0;
        this.totalCount = params.length;
        if(!params.length) return this.toastInfo('[선텍된 레코드 없음] 좌측의 번호를 클릭하여 레코드 선택');

        const confirmMsg = `${params.length} 개의 데이터를 삭제 합니다. 삭제된 데이터는 복구할 수 없습니다. 진행 하시겠습니까?`;

        if( !(await this.confirmModal(confirmMsg, '레코드 삭제')) ){
          return;
        }

        let failCnt = 0;
        for( let record of params){
          console.log( "deleteRecord for --------->", record );
          const tIndex = this.$refs['excelGrid'].rowIndex[record.$id];
          const r = await apiCall('DEL', `/api/notice/user/${record._id}`);
          console.log( r );
          if( r.code===200 ){
            this.progCount++;
            await this.$refs["excelGrid"].deleteRecord(tIndex);
          }
        }

        await this.alertModal(`삭제: ${this.progCount}건, 실패: ${failCnt}`, '레코드 삭제결과', 'warning');
        this.$refs['excelGrid'].clearAllSelected();
        this.selectedRows = [];
        await this.getList();

      }catch(err){

        console.log( err );
      }
    },




  } // end of methods
}
</script>

<style scoped>
/* 대상탱크 폼: 콤보/버튼 축소 (CSelect 내부 select 는 자식 컴포넌트라 ::v-deep 필요) */
.ctl-tank-form ::v-deep select,
.ctl-tank-form .btn {
  font-size: 0.8rem;
  padding-top: 0.22rem;
  padding-bottom: 0.22rem;
}
.ctl-tank-form .area-select ::v-deep select {
  background-color: #2f303a;
  width: 145px;
}
.ctl-tank-form .tank-select ::v-deep select {
  background-color: #2f303a;
  width: 185px;
}
/* 대상탱크 배지: 기본 primary 보다 약간 밝게 */
.tid-badges .badge-primary {
  background-color: #4f5fe3;
}
</style>
